import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export function TarjetasOkPage() {
  return (
    <div className="max-w-md mx-auto mt-12 text-center space-y-4">
      <CheckCircle className="mx-auto h-16 w-16 text-green-600" aria-hidden />
      <h1 className="text-xl font-semibold text-[#2C2C2C]">Tarjeta añadida correctamente</h1>
      <p className="text-sm text-gray-600">
        Ya puedes usarla como método de pago para los cobros automáticos.
      </p>
      <Link
        to="/dashboard/tarjetas"
        className="inline-block rounded-lg bg-[#1A3AB8] px-4 py-2.5 text-sm font-medium text-white hover:bg-[#15308a]"
      >
        Volver a Mis tarjetas
      </Link>
    </div>
  );
}
